module.exports = __webpack_public_path__ + "static/poppins-v5-latin-700-a02d5c2b023be148d8d23d3b877d4745.svg";